import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Telegram WebApp (guard unsupported features by version)
const initializeTelegramWebApp = () => {
  if (window.Telegram?.WebApp) {
    const webApp = window.Telegram.WebApp;

    // Expand the mini app to full height
    webApp.expand();

    // Feature guards for older Telegram versions
    const ver = webApp.version || '0.0';
    const [majStr] = String(ver).split('.');
    const major = parseInt(majStr || '0', 10);

    // Set the header color if supported (>= 7)
    try {
      if (major >= 7 && typeof webApp.setHeaderColor === 'function') {
        webApp.setHeaderColor('#1a1a1a');
      }
    } catch (_) {}

    // Enable closing confirmation if supported (>= 7)
    try {
      if (major >= 7 && typeof webApp.enableClosingConfirmation === 'function') {
        webApp.enableClosingConfirmation();
      }
    } catch (_) {}

    console.log('Telegram WebApp initialized:', {
      initData: webApp.initData,
      user: webApp.initDataUnsafe?.user,
      platform: webApp.platform,
    });

    return webApp;
  }
  return null;
};

// Initialize WebApp when DOM is ready
document.addEventListener('DOMContentLoaded', initializeTelegramWebApp);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
